import {CurrentUser} from "../../../services/user/models/CurrentUser";
import {FeatureNames} from "../../../types/UserConfig";

export type OrderListLayout = "equity" | "option" | "none";

export function userOrderListLayout(user: CurrentUser): OrderListLayout {
    if (user.hasFeature(FeatureNames.SCREEN_OPTION_ORDERS)) {
        return "option";
    } else if (user.hasFeature(FeatureNames.SCREEN_EQUITY_ORDERS)) {
        return "equity";
    } else {
        return "none";
    }
}
